export default "__VITE_ASSET__CGZaAL97__"